import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { PaymentInterface, WorkYears } from "./types";
import { useTranslation } from "react-i18next";
import { DoctorInterface } from "../doctors/types";
import CellPayment from "./CellPayment";

const DataPayments = () => {
  const { payments } = useSelector((state: State) => state.payments);
  const { t } = useTranslation();

  const [paymentsByDoctor, setPaymentsByDoctor] = useState<any[]>([]);

  const { medecinTypes } = useSelector((state: State) => state.medecinType);
  const [typeMedecin, setTypeMedecin] = useState(medecinTypes[1]?.title);

  useEffect(() => {
    setPaymentsByDoctor(
      payments
        ?.slice()
        ?.filter((payment: PaymentInterface) =>
          !payment?.doctor?.status?.disappeared ? true : false
        )
        ?.filter(
          (payment: PaymentInterface) =>
            payment?.doctor?.medecinType?.title === typeMedecin
        )
        ?.sort(
          (a: PaymentInterface, b: PaymentInterface) =>
            Number(a.doctor?.RegNo) - Number(b.doctor?.RegNo)
        )
        .reduce((acc: any, payment: PaymentInterface) => {
          const doctorKey: any = `${payment.doctor?.RegNo}`;

          if (!acc[doctorKey]) {
            acc[doctorKey] = [];
          }

          acc[doctorKey].push(payment);
          return acc;
        }, {})
    );
  }, [payments, typeMedecin]);

  return (
    <>
      <div className="flex items-center justify-between flex-wrap gap-4 mb-6 px-1">
        <div className="flex items-center gap-4">
          <p className="text-base font-medium text-gray-700">
            {t("Type de médecin")}
          </p>
          <div className="flex flex-wrap gap-3">
            {medecinTypes.map((medecin: any) => (
              <label
                key={medecin._id}
                htmlFor={medecin?.title}
                className={`flex items-center gap-2 px-4 py-1.5 rounded-lg border cursor-pointer transition
            ${
              typeMedecin === medecin?.title
                ? "bg-blue-100 border-blue-500 text-blue-700"
                : "bg-white border-gray-300 hover:border-blue-400"
            }
          `}
              >
                <input
                  type="radio"
                  id={medecin?.title}
                  name="medecintype"
                  value={medecin?.title}
                  checked={typeMedecin === medecin?.title}
                  onChange={() => setTypeMedecin(medecin?.title)}
                  className="form-radio text-blue-600 focus:ring-blue-500"
                />
                <span className="capitalize">{medecin?.title}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-xl border border-gray-300 shadow-sm bg-white overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-700">
            <thead className="sticky top-0 bg-white z-10 shadow-sm">
              <tr>
                <th
                  colSpan={2}
                  className="px-6 py-4 bg-gray-100 border-b border-gray-300 text-center text-sm font-semibold uppercase tracking-wide text-gray-700"
                >
                  {t("Informations")}
                </th>
                <th
                  colSpan={WorkYears.length}
                  className="px-6 py-4 bg-gray-100 border-b border-gray-300 text-center text-sm font-semibold uppercase tracking-wide text-gray-700"
                >
                  {t("Années")}
                </th>
              </tr>
              <tr className="bg-main text-white uppercase text-xs tracking-wider">
                <th className="px-6 py-3 border-b border-gray-300 text-left">
                  {t("Numero")}
                </th>
                <th className="px-6 py-3 border-b border-gray-300 text-left">
                  {t("Nom complet")}
                </th>
                {WorkYears.map((year: string) => (
                  <th
                    key={year}
                    className="px-6 py-3 border-b border-gray-300 text-center"
                  >
                    {year}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {Object.keys(paymentsByDoctor)?.map((doctorKey: any, index) => {
                const doctorPayments: any = paymentsByDoctor[doctorKey] || [];
                const paymentInfo: PaymentInterface = doctorPayments?.find(
                  (dc: any) => dc.doctor?.RegNo === doctorKey
                );
                const doctorInfo: DoctorInterface = doctorPayments[0]?.doctor;

                return (
                  <tr key={index} className="hover:bg-gray-50 transition">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {doctorKey}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {doctorInfo?.fullName}
                    </td>
                    <CellPayment
                      doctorPayments={doctorPayments}
                      paymentInfo={paymentInfo}
                      doctorInfo={doctorInfo}
                    />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default DataPayments;
